export var EScoreColor;
(function (EScoreColor) {
    EScoreColor["DANGER"] = "danger";
    EScoreColor["SUCCESS"] = "success";
})(EScoreColor || (EScoreColor = {}));
export var EMessageSender;
(function (EMessageSender) {
    EMessageSender["CANDIDATE"] = "CANDIDATE";
    EMessageSender["INTERVIEWER"] = "INTERVIEWER";
    EMessageSender["FOLLOWUP"] = "FOLLOWUP";
    EMessageSender["BOT"] = "BOT";
})(EMessageSender || (EMessageSender = {}));
